import { BaseAPI } from "../../BaseAPI";
import { v4 as uuidv4 } from 'uuid';
import * as environment from '../../../config/environment';
 
class SmsDogrulamaKontrolAPI extends BaseAPI {
 
 
  constructor () {
    const baseUrl = environment.API_URL + "SmsDogrulamaKontrol";
    super(baseUrl);
  }
 
 
  saveSmsDogrulamaKontrolSave(request: SmsDogrulamaKontrolRequest){
   
     const isLogin = request.isLogin ? true : false;
     return this.post(`?isLogin=${isLogin}`, request,false);
   
  }
 
}
export default new SmsDogrulamaKontrolAPI();
 
class SmsDogrulamaKontrolRequest {
    tcKimlikNo: string;
    vergiNo?: string;
    sicilNo?: number;
    aboneNo?: number;
    referansNo: string;
    smsDogrulamaKodu: string;
    isMail?: boolean;
    isLogin?: boolean;
 
    constructor(
        tcKimlikNo: string,
       
        referansNo: string,
        smsDogrulamaKodu: string,
        vergiNo?: string,
        sicilNo?: number,
        aboneNo?: number,
        isMail: boolean=false,
        isLogin?: boolean
    ) {
        this.tcKimlikNo = tcKimlikNo;
        this.vergiNo = vergiNo;
        this.referansNo = referansNo;
        this.smsDogrulamaKodu = smsDogrulamaKodu;
        this.sicilNo = sicilNo;
        this.aboneNo = aboneNo;
        this.isMail = isMail;
        this.isLogin = isLogin;
    }
}
export { SmsDogrulamaKontrolRequest };